import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useImportServiceJobsMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IImportServiceJobPreview) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ file, impersonationContext }: { file: File; impersonationContext?: Api.IImpersonationContext }) => {
			const data = new FormData();
			data.append('file', file);

			return userSession.webServiceHelper.callAsync<Api.IImportServiceJobPreview>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `ServiceJob/importFromFile`,
				}),
				'POST',
				data
			);
		},
		onError,
		onSuccess,
	});
};
